






















import { defineComponent } from '@nuxtjs/composition-api';
import useContactForm from '@shared/composables/useContactForm';
import { StoryblokContactForm, UCContactFormVehicleSearchField } from '@shared/ui';

export default defineComponent({
  name: 'ContactForm',
  components: {
    StoryblokContactForm,
    UCContactFormVehicleSearchField,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    // eslint-disable-next-line vue/prop-name-casing
    button_text: {
      type: String,
      required: true,
    },
    fields: {
      type: Array,
      required: true,
    },
  },
  setup() {
    return useContactForm({
      formId: Date.now().toString(),
      emailSubject: 'AMX Online Enquiry',
    });
  },
});
